module.exports = __webpack_public_path__ + "img/hrms2.09130542.png";